"use client";

import { ReactNode, useState } from "react";
import { cn } from "@/lib/utils";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
import { SliderWrapper } from "@/components/common/slider-wrapper";

export const CardGrid = ({
  items,
  activeIndex = 0,
  showSlider = true,
  double = false,
}: {
  items: ReactNode[];
  activeIndex?: number;
  showSlider?: boolean;
  double?: boolean;
}) => {
  const [api, setApi] = useState<CarouselApi | null>(null);

  const defaultStyles = cn(
    "hidden gap-4 gap-y-6 @min-[600px]:grid",
    "@min-[600px]:grid-cols-2 @min-[600px]:gap-6 @min-[600px]:gap-y-8",
    "@min-[900px]:grid-cols-3",
    "@min-[1200px]:grid-cols-4",
    "@min-[1500px]:grid-cols-5 @min-[1500px]:gap-8 @min-[1500px]:gap-y-12",
    "@min-[2000px]:grid-cols-6",
    "@min-[2500px]:grid-cols-7",
    "@min-[3000px]:grid-cols-8",
    "@min-[3500px]:grid-cols-9",
    !showSlider && "grid",
  );

  const doubledStyles = cn(
    "hidden gap-4 gap-y-6 @min-[600px]:grid",
    "@min-[900px]:grid-cols-2 @min-[900px]:gap-12 @min-[900px]:gap-y-12",
    !showSlider && "grid",
  );

  return (
    <div className={"@container my-6"}>
      <div
        className={cn(
          "hidden sm:overflow-hidden",
          showSlider && "@max-[600px]:block",
        )}
      >
        <SliderWrapper api={api} activeIndex={activeIndex}>
          <Carousel
            opts={{
              skipSnaps: true,
            }}
            setApi={setApi}
            plugins={[WheelGesturesPlugin()]}
          >
            <CarouselContent>
              {items.map((item, index) => (
                <CarouselItem
                  className={cn("grid basis-[280px] md:basis-[300px]")}
                  key={index}
                  isFirst={index === 0}
                  isLast={index === items.length - 1}
                >
                  {item}
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </SliderWrapper>
      </div>

      <div className={!double ? defaultStyles : doubledStyles}>{items}</div>
    </div>
  );
};
